import { DashboardData } from "../../models/interfaces/reports/dashboard-data";
import { Group } from "../../models/interfaces/group";
import { GroupIds } from "../../models/enumerations/group-ids";

export const DEMO_DASHBOARD_DATA: DashboardData = {
    activeUsers: 9,
    inactiveUsers: 15,
    pendingUsers: 36,
    percent: 60,
    history: [
        { date: "2025-05-01", percent: 48 },
        { date: "2025-06-01", percent: 60 },
        { date: "2025-07-01", percent: 63 },
        { date: "2025-08-01", percent: 34 },
        { date: "2025-09-01", percent: 61 },
        { date: "2025-10-01", percent: 29 },
        { date: "2025-11-01", percent: 59 },
        { date: "2025-12-01", percent: 66 },
        { date: "2026-01-01", percent: 63 },
        { date: "2026-02-01", percent: 57 },
        { date: "2026-03-01", percent: 60 },
        { date: "2026-04-01", percent: 60 },
    ],
    scoreBreakdown: [
        { name: "0-9", count: 0 },
        { name: "10-19", count: 2 },
        { name: "20-29", count: 3 },
        { name: "30-39", count: 10 },
        { name: "40-49", count: 15 },
        { name: "50-59", count: 24 },
        { name: "60-69", count: 28 },
        { name: "70-79", count: 19 },
        { name: "80-89", count: 11 },
        { name: "90+", count: 6 },
    ],
    riskFactorCodeCounts: [
        { name: "Health", count: 79 },
        { name: "Wellness", count: 10 },
        { name: "Fitness", count: 24 },
        { name: "Performance", count: 5 },
    ],
    focusAreas: [
        { groupId: GroupIds.BREATHING, name: "Breathing Quality", count: 54 },
        { groupId: GroupIds.MOVEMENT_HEALTH, name: "Movement Health", count: 44 },
        { groupId: GroupIds.PHYSICAL_ACTIVITY, name: "Physical Activity", count: 36 },
        { groupId: GroupIds.INJURY_HISTORY, name: "Injury History", count: 34 },
        { groupId: GroupIds.BEHAVIORAL_HEALTH, name: "Behavioral Health", count: 23 },
        { groupId: GroupIds.SLEEP, name: "Sleep Wellness", count: 10 },
        { groupId: GroupIds.NUTRITION, name: "Nutrition Awareness", count: 5 },
        { groupId: GroupIds.BODY_COMPOSITION, name: "Body Composition", count: 3 },
    ],
};

export const DEMO_GROUPS: Group[] = [
    { id: "demo-group-1", name: "Demo Group 1", organizationId: "4PFeK2nilNGSiwXejB2o" },
    { id: "demo-group-2", name: "Demo Group 2", organizationId: "4PFeK2nilNGSiwXejB2o" },
];